<script>
  import { alert } from 'vue-strap';
  import MateriaisDeConsumo from './FormListaMateriaisDeConsumo.vue';
  import Livros from './FormListaLivros.vue';
  import Equipamentos from './FormListaEquipamentos.vue';
  import ContratacaoDeServicos from './FormListaContratacaoDeServicos.vue';
  import LocacaoDeVeiculos from './FormListaLocacaoDeVeiculos.vue';
  import ReservaDeHotel from './FormListaReservaDeHotel.vue';
    import Importacao from './FormListaImportacao.vue';
    import ComprasOnline from './FormListaComprasOnline.vue';
    import ComprasInternas from './FormListaComprasInternas.vue';

  export default {
    components: { 
      alert, 
      MateriaisDeConsumo,
      Livros,
      Equipamentos,
      ContratacaoDeServicos,
      LocacaoDeVeiculos,
      ReservaDeHotel,
      Importacao,
      ComprasOnline,
      ComprasInternas
    },
    props: {
      itensSolicitacaoCompra: Array,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      deletarItem(indice) {
        this.itensSolicitacaoCompra.splice(indice, 1);
      },
      editarItem(indice) {
        this.$emit('editarItem', indice);
      }
      
    },
    computed: {
      total: function() {
        return this.itensSolicitacaoCompra.reduce((somatorio, item) => {
          const valorEstimado = this.$options.filters.formatarNumero(item.valorEstimado, true);
          const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);

          return somatorio + (quantidade * valorEstimado)
        }, 0);
      }
    }
  }
</script>

<template>

  <div>
    <alert type="warning" v-if="itensSolicitacaoCompra.length === 0">
      <i class="fa fa-warning"></i> Nenhum item adicionado.
    </alert>

    <div class="bs-callout bs-callout-info no-margin-top" v-for="(item, index) in itensSolicitacaoCompra">
        <h4>
            Item #{{ index + 1 }}
            
            <button type="button"
                    class="btn btn-sm btn-warning btn-delete-item"
                    title="Editar item"
                    @click="editarItem(index)"
                    style="right: 73px;"
                    v-if="!relatorio">
              <i class="fa fa-pencil"></i>
            </button>

            <button type="button"
                    class="btn btn-sm btn-danger btn-delete-item"
                    title="Excluir item"
                    @click="deletarItem(index)"
                    v-if="!relatorio">
                <i class="fa fa-trash"></i>
            </button>
        </h4>

        <materiais-de-consumo :item="item" v-if="item.tipoCompra === '' || item.tipoCompra === '01'"
                              :relatorio="relatorio">
        </materiais-de-consumo>

        <livros :item="item" v-if="item.tipoCompra === '04'"
                :relatorio="relatorio">
        </livros>

        <equipamentos :item="item" v-if="item.tipoCompra === '05'"
                      :relatorio="relatorio">
        </equipamentos>

        <contratacao-de-servicos :item="item" v-if="item.tipoCompra === '06'"
                                 :relatorio="relatorio">
        </contratacao-de-servicos>

        <locacao-de-veiculos :item="item" v-if="item.tipoCompra === '06b'"
                             :relatorio="relatorio">
        </locacao-de-veiculos>

        <reserva-de-hotel :item="item" v-if="item.tipoCompra === '09'"
                          :relatorio="relatorio">
        </reserva-de-hotel>

        <importacao :item="item" v-if="item.tipoCompra === '10'"
                    :relatorio="relatorio">
        </importacao>

        <compras-online :item="item" v-if="item.tipoCompra === '13'"
                        :relatorio="relatorio">
        </compras-online>

        <compras-internas :item="item" v-if="item.tipoCompra === '14'"
                        :relatorio="relatorio">
        </compras-internas>
    </div>

    <div class="bs-callout bs-callout-primary" v-if="configuracao.utilizarValorEstimado">
      <h4>Valor total estimado: R$ {{ total | formatarNumero }}</h4>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaItens.vue